import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
const AdminReferralCodes = lazy(() => import("@/pages/admin/AdminReferralCodes"));

export const Route = createFileRoute("/admin/referral-codes")({
  component: AdminReferralCodes,
});
